import {
  mapActions,
  mapGetters
} from 'vuex';
import InscriptionI18n from './Inscription.i18n.js';

export default {

  components: {},

  props: {},

  computed: {
    ...mapGetters(['loggingLoading']),
    isPasswordValid() {
      if (this.password1 === '' && this.password2 === '') {
        return null
      } else {
        if (this.password2 === this.password1 && this.password1.length > 7 && this.password2.length > 7) {
          return true
        } else {
          return false
        }
      }
    }
  },

  data() {
    return {
      emailLogin: '',
      passwordLogin: '',
      email: '',
      password1: '',
      password2: '',
      isSucces: false,
      errorPassword: false,
      name: '',
      inscriptionDone: false
    };
  },

  watch: {},

  methods: {
    ...mapActions(['createUser', 'loggin', 'register', 'getUser']),
    enregistre() {
      const info = {
        email: this.email,
        password: this.password1,
        name: this.name
      }
      this.register(info).then(res => {
        this.isSucces = true
        this.inscriptionDone = true
      }).catch(err => {
        console.log(err)
      })
    },
    login() {
      this.errorPassword = false
      const user = {
        email: this.emailLogin,
        password: this.passwordLogin
      }
      this.loggin(user).then(res => {
        this.getUser().then(() => {
          if (localStorage.getItem('isFromCart')) {
            localStorage.removeItem('isFromCart')
            this.$router.push('/commande')
          } else {
            this.$router.push('/')
          }
        }).catch(err => {
          console.log(err)
        })
      }).catch(err => {
        console.log(err)
        this.errorPassword = true
      })
    }
  },

  mounted() {
    console.log(this.$route)
    window.scrollTo(0, 0)
  },

  i18n: InscriptionI18n,

};